import * as React from "react"

const ViewDocumentSVG = (props) => (
	<svg width={18} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M10 1v7h7M3 5H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-1M5 2v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7.389a1 1 0 0 0-.263-.676l-4.94-5.389A1 1 0 0 0 11.06 1H6a1 1 0 0 0-1 1Z"
			//stroke="#3476E4"
			//stroke="#475163"
			stroke="currentColor"
			strokeWidth={1.5}
			strokeLinejoin="round"
		/>
	</svg>
)

export default ViewDocumentSVG
